import React, { useEffect, useState, useMemo } from "react"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"

import { Button, Card, CardBody, Container } from "reactstrap"

import { TextCell, DateCell, IdCell, StatusCell } from "./diplomaListCol"
import { listAllDiplomas } from "helpers/api_helper"
import TableContainerWithModal from "components/Common/TableContainerWithModal"
import Breadcrumbs from "components/Common/Breadcrumb"

const AllDiplomaList = props => {
  document.title = "All Diploma List | Diplom.mn"

  const [apiData, setApiData] = useState(null)

  const fetchCredits = async () => {
    try {
      const r = await listAllDiplomas()
      const err = r
      if (err?.message != "error") {
        setApiData(r.records)
      }
    } catch (error) {
      return "error"
    }
  }
  useEffect(() => {
    fetchCredits()
  }, [])
  const [modal1, setModal1] = useState(false)

  const toggleViewModal = () => setModal1(!modal1)
  const columns = useMemo(
    () => [
      {
        Header: "Date",
        accessor: "createTxTimestamp",
        disableFilters: true,
        filterable: false,
        Cell: cellProps => {
          return <DateCell {...cellProps} />
        },
      },
      {
        Header: "ID",
        accessor: "id",
        filterable: false,
        disableFilters: true,
        Cell: cellProps => {
          return <IdCell {...cellProps} />
        },
      },
      {
        Header: "First Name",
        accessor: "claims.extras.hemisDiploma.FIRST_NAME",
        disableFilters: true,
        filterable: false,
        Cell: cellProps => {
          return <TextCell {...cellProps} />
        },
      },
      {
        Header: "Total GPA",
        accessor: "claims.extras.hemisDiploma.TOTAL_GPA",
        disableFilters: true,
        filterable: false,
        Cell: cellProps => {
          return <TextCell {...cellProps} />
        },
      },
      {
        Header: "Upload Status",
        accessor: "status",
        disableFilters: true,
        filterable: false,
        Cell: cellProps => {
          return <StatusCell {...cellProps} />
        },
      },
      {
        Header: "View Details",
        disableFilters: true,
        accessor: "view",
        Cell: cellProps => {
          return (
            <Button
              type="button"
              color="primary"
              className="btn-sm btn-rounded"
              onClick={() => toggleViewModal()}
            >
              View Details
            </Button>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Diploma"
            breadcrumbItem="All Diploma List"
          />
          <Card>
            <CardBody>
              <div className="mb-4 h4 card-title">Latest Uploads</div>
              <TableContainerWithModal
                columns={columns}
                data={apiData ? apiData : []}
                isGlobalFilter={true}
                isAddOptions={false}
                isPagination={true}
                iscustomPageSizeOptions={true}
                customPageSize={4}
                pagination="pagination pagination-rounded justify-content-end mb-2"
                modalState={modal1}
                toggleViewModal={toggleViewModal}
                isUpload={false}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

AllDiplomaList.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
}

export default AllDiplomaList
